// src/data/salonData.js
export const categories = [
  { id: "hair", label: "Hair" },
  { id: "nails", label: "Nails" },
  { id: "facial", label: "Facial" },
];

export const products = {
  hair: [
    { id: "haircut", name: "Haircut", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true,withoutQuantity:true},
    { id: "hair-color", name: "Hair Coloring", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true ,withoutQuantity:true},
  ],
  nails: [
    { id: "manicure", name: "Manicure", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true,withoutQuantity:true },
    { id: "pedicure", name: "Pedicure", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true,withoutQuantity:true },
  ],
  facial: [
    { id: "facial-treatment", name: "Facial Treatment", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true,withoutQuantity:true },
  ],
};